export default __webpack_public_path__ + "static/media/tz.ac134c24.svg";